module.exports = __webpack_public_path__ + "static/media/line.2c117e75.svg";